import { Splide } from '../vendors/splide.esm';

class Carousel {
    constructor(id, config) {
        this.el = document.getElementById(id);
        this.config = config;
        this.carousel = null;
        this.state = true;
        this.statesp = true;
        this.isDragging = false;
        this.init();
    }

    init() {
        if (this.el) {
            const _this = this;
            this.carousel = new Splide(this.el, this.config);
            let barEl = this.carousel.root.querySelector('.jsProgressBar');
            const progressEl = this.carousel.root.querySelector('.splide__progress');

            this.carousel.on('mounted move', () => {
                if (this.isDragging || !barEl) return;
                const end = this.carousel.Components.Controller.getEnd() + 1;
                const rate = (this.carousel.index + 1) / end;
                barEl.style.width = (rate * 100) + '%';
            });

            if (progressEl && barEl) {
                const getPercent = (clientX) => {
                    const rect = progressEl.getBoundingClientRect();
                    let percent = (clientX - rect.left) / rect.width;
                    return Math.max(0, Math.min(1, percent));
                };

                progressEl.addEventListener('mousedown', (e) => {
                    this.isDragging = true;
                    barEl.classList.add('is-dragging');
                });

                window.addEventListener('mousemove', (e) => {
                    if (!this.isDragging) return;
                    const percent = getPercent(e.clientX);
                    barEl.style.width = (percent * 100) + '%';
                });

                window.addEventListener('mouseup', (e) => {
                    if (!this.isDragging) return;
                    this.isDragging = false;
                    barEl.classList.remove('is-dragging');
                    const percent = getPercent(e.clientX);
                    const total = this.carousel.Components.Controller.getEnd() + 1;
                    const index = Math.floor(percent * total);
                    this.carousel.go(index);
                });
            }

            this.carousel.mount();
        }
    }
}

export function renderCarousel() {
    let carouselSuggestEl = document.getElementById('jsCarouselSuggest');
    if (carouselSuggestEl) {
        new Carousel(carouselSuggestEl.id, {
            autoWidth: false,
            perMove: 1,
            perPage: 4,
            gap: '15px',
            drag: false,
            speed: 1000,
            pagination: false,
            arrows: false,
            breakpoints: {
                992: {
                    drag: true,
                    autoWidth: true,
                    type: 'loop',
                },
            },
        });
    }

    let carouselSingleEl = document.getElementById('jsCarouselSingle');
    if (carouselSingleEl) {
        new Carousel(carouselSingleEl.id, {
            autoWidth: false,
            autoplay: true,
            speed: 1000,
            pagination: true,
            arrows: false,
            type: 'loop',
            reducedMotion: {
                interval: 4000,
                speed: 1000,
                autoplay: 'play'
            }
        });
    }

    let carouselKatariEl = document.getElementById('jsCarouselKatari');
    if (carouselKatariEl) {
        new Carousel(carouselKatariEl.id, {
            type: 'loop',
            autoWidth: false,
            autoplay: true,
            speed: 1000,
            gap: 20,
            pagination: true,
            arrows: false,
            reducedMotion: {
                interval: 4000,
                speed: 1000,
                autoplay: 'play'
            }
        });
    }

    let carouselAnchorEl = document.getElementById('jsCarouselAnchor'),
        carouselAnchor = null;
    if (carouselAnchorEl) {
        carouselAnchor = new Carousel(carouselAnchorEl.id, {
            autoWidth: true,
            autoplay: false,
            gap: '5px',
            perMove: 1,
            speed: 500,
            pagination: false,
            arrows: false,
        });
    }

    let offsetTop = 191,
        stickyAnchorEl = document.getElementById('jsStickyAnchor'),
        stickyContentEls = document.querySelectorAll('.jsStickyContent'),
        anchorEls = document.querySelectorAll('#jsCarouselStickyLink .jsAnchor'),
        idPage = document.body.id;
    if (window.innerWidth <= 992) {
        offsetTop = 183;
    }

    const anchorMap = new Map();
    anchorEls.forEach(anchor => {
        anchorMap.set(anchor.dataset.anchor, anchor);
    });

    let carouselStickyLink = null;
    function activeCarouselStickyLink() {
        let carouselStickyLinkEl = document.getElementById('jsCarouselStickyLink');
        if (carouselStickyLinkEl && window.innerWidth <= 992) {
            carouselStickyLink = new Splide(carouselStickyLinkEl, {
                drag: false,
                destroy: true,
                breakpoints: {
                    992: {
                        pagination: false,
                        arrows: false,
                        speed: 500,
                        perMove: 1,
                        drag: true,
                        autoWidth: true,
                        destroy: false,
                        center: true,
                        gap: idPage === 'pageGenre' ? '5px' : '0',
                    },
                },
                state: 'sticky'
            });
            let barEl = carouselStickyLink.root.querySelector('.jsProgressBar');
            const trackEl = barEl ? barEl.parentElement : null;

            carouselStickyLink.on('mounted move', function () {
                const end = carouselStickyLink.Components.Controller.getEnd() + 1;
                const index = carouselStickyLink.index;

                if (barEl && trackEl) {
                    const trackWidth = trackEl.clientWidth;
                    const thumbWidthPercent = Math.max(100 / end, 12);
                    const thumbWidth = (thumbWidthPercent / 100) * trackWidth;
                    const maxOffset = trackWidth - thumbWidth;
                    const progress = end > 1 ? index / (end - 1) : 0;
                    const offset = progress * maxOffset;

                    barEl.style.width = thumbWidthPercent + '%';
                    barEl.style.transform = `translateX(${offset}px)`;
                }
            });
            carouselStickyLink.mount();
        }
    }

    function setCurrentAnchor(id) {
        anchorEls.forEach(anchor => anchor.classList.remove('current'));
        const activeAnchor = anchorMap.get(id);
        if (activeAnchor) {
            activeAnchor.classList.add('current');

            if (carouselStickyLink) {
                const index = Array.from(anchorEls).indexOf(activeAnchor);
                if (index !== -1) {
                    carouselStickyLink.go(index);
                }
            }
        }
    }

    function getOffsetTop(el) {
        let offset = 0;
        while (el) {
            offset += el.offsetTop;
            el = el.offsetParent;
        }
        return offset;
    }

    function scrollSticky() {
        if (!stickyAnchorEl) return;
        let stickyTop = parseInt(getComputedStyle(stickyAnchorEl).top) || 0;
        let currentTop = stickyAnchorEl.getBoundingClientRect().top;

        if (currentTop <= stickyTop) {
            stickyAnchorEl.dataset.state = 'sticky';
        } else {
            stickyAnchorEl.dataset.state = '';
        }

        const scrollPos = window.scrollY + offsetTop;
        let currentId = null;

        stickyContentEls.forEach(section => {
            const sectionTop = getOffsetTop(section);
            if (scrollPos >= sectionTop - 30) {
                currentId = section.id;
            }
        });

        if (!currentId && idPage === 'pageOptionMenu' && anchorEls.length > 0) {
            currentId = anchorEls[0].dataset.anchor;
        }

        if (currentId) {
            setCurrentAnchor(currentId);
        }
    }

    let carouselKeyvEl = document.getElementById('jsCarouselKeyv');
    if (carouselKeyvEl) {
        new Carousel(carouselKeyvEl.id, {
            autoWidth: false,
            autoplay: true,
            speed: 1000,
            pagination: true,
            arrows: true,
            type: 'fade',
            rewind: true,
            reducedMotion: {
                interval: 4000,
                speed: 1000,
                autoplay: 'play'
            },
            breakpoints: {
                768: {
                    arrows: false,
                },
            },
        });
    }

    let carouselLecturerEl = document.getElementById("jsCarouselLecturer");
    if (carouselLecturerEl) {
        const carouselLecturer = new Carousel(carouselLecturerEl.id, {
            autoWidth: false,
            speed: 1000,
            pagination: false,
            arrows: true,
        });

        const lecturerControlEl = document.querySelector(
            "#jsCarouselLecturerControl",
        );
        if (lecturerControlEl && carouselLecturer.carousel) {
            const controlLinks = lecturerControlEl.querySelectorAll("a");
            const setActiveControl = (index) => {
                controlLinks.forEach((link) => link.classList.remove("active"));
                const activeLink = lecturerControlEl.querySelector(
                    `a[id="${index}"]`,
                );
                if (activeLink) {
                    activeLink.classList.add("active");
                }
            };

            lecturerControlEl.addEventListener("click", (event) => {
                const target = event.target.closest("a");
                if (!target) return;
                const index = Number.parseInt(target.id, 10);
                if (Number.isNaN(index)) return;
                event.preventDefault();
                setActiveControl(index);
                carouselLecturer.carousel.go(index);
            });

            carouselLecturer.carousel.on("mounted move", () => {
                setActiveControl(carouselLecturer.carousel.index);
            });
        }
    }

    function renderSlide(el) {
        const mobileW = 768,
            slideConfig = {
                drag: false,
                destroy: true,
                breakpoints: {
                    768: {
                        pagination: false,
                        arrows: false,
                        speed: 1000,
                        perMove: 1,
                        drag: true,
                        autoWidth: true,
                        destroy: false,
                        type: el.dataset.state === 'scroll' ? 'slide' : 'loop',
                        focus: el.dataset.state === 'center' ? el.dataset.state : '',
                        gap: '20px'
                    },
                }
            };
        if (el.id === 'jsCarouselUserTop') {
            if (window.innerWidth <= mobileW) {
                let slideEls = el.querySelectorAll('.splide__slide ')
                if (slideEls.length > 0) {
                    let btnEl = slideEls[slideEls.length - 1].querySelector('.e-btn--1');
                    if (btnEl) {
                        el.appendChild(btnEl.cloneNode(true));
                        slideEls[slideEls.length - 1].remove();
                        new Carousel(el.id, slideConfig);
                    }
                }
            } else {
                let checkEls = el.querySelectorAll('.splide__slide .e-btn--1');
                if (checkEls.length === 0) {
                    let btnEl = el.querySelector('.e-btn--1');
                    if (btnEl) {
                        let slideEl = window.createTag('div', { className: 'splide__slide' });
                        slideEl.appendChild(btnEl.cloneNode(true));
                        el.querySelector('.splide__list').appendChild(slideEl);
                        btnEl.remove();
                    }
                }
            }
        } else {
            new Carousel(el.id, slideConfig);
        }
    }

    function initCarousel(el) {
        renderSlide(el);
        window.addEventListener('resize', () => {
            renderSlide(el);
        });
    }

    let carouselUserEls = document.querySelectorAll('.jsCarouselUser');
    if (carouselUserEls.length > 0) {
        carouselUserEls.forEach(carouselUserEl => {
            initCarousel(carouselUserEl);
        });
    }

    function scrollActiveAnchor() {
        const stickyBoxEls = document.querySelectorAll('.jsStickyBox'),
            anchorEls = document.querySelectorAll('.jsAnchor'),
            stickyAnchorEl = document.getElementById('jsStickyAnchor');
        stickyBoxEls.forEach(stickyBoxEl => {
            const rect = stickyBoxEl.getBoundingClientRect();
            const stickyH = stickyBoxEl.dataset.type === 'sticky' ? 153 : 0;
            const offsetTop = rect.top + scrollY - (innerWidth <= 992 ? 123 : 76) - stickyH;
            const inRange = pageYOffset >= offsetTop && pageYOffset <= offsetTop + rect.height;
            if (!inRange) return;
            anchorEls.forEach(el => el.classList.remove('current'));
            const anchorEl = Array.from(anchorEls).find(el => el.dataset.anchor === stickyBoxEl.id);
            const anchorIndex = Array.from(anchorEls).findIndex(el => el.dataset.anchor === stickyBoxEl.id);
            if (anchorIndex !== -1 && carouselAnchor) {
                carouselAnchor.carousel.go(anchorIndex);
                anchorEl.classList.add('current');
                stickyAnchorEl.classList.add('sticky');
            }
        });
        if (pageYOffset === 0 && document.body.id !== 'pageOptionMenu') {
            anchorEls.forEach(el => el.classList.remove('current'));
            if (stickyAnchorEl) {
                stickyAnchorEl.classList.remove('sticky');
            }
        }
    }

    const carouselSpecialEl = document.getElementById("jsCarouselSpecial");

    if(carouselSpecialEl) {
        let carouselInstance = null;
        let originalHTML = carouselSpecialEl.innerHTML;
        let originalSlideCount =
            carouselSpecialEl.querySelectorAll(".splide__slide").length;
        let lastIsMobile = window.innerWidth <= 768;
        const getMinItems = () => (window.innerWidth <= 768 ? 2 : 3);
        const shouldEnableCarousel = () => originalSlideCount > getMinItems();
        const createCarousel = () => {
            if (carouselInstance) return;
                carouselInstance = new Carousel(carouselSpecialEl.id, {
                autoplay: true,
                autoWidth: true,
                arrows: true,
                speed: 1000,
                perMove: 1,
                pagination: false,
                type: 'loop',
                gap: '40px',
                rewind: true,
                reducedMotion: {
                    interval: 4000,
                    speed: 1000,
                    autoplay: 'play',
                },
                breakpoints: {
                    768: {
                        arrows: false,
                        gap: '20px'
                    },
                },
            });
        };

        const destroyCarousel = () => {
            if (!carouselInstance) return;
            carouselInstance.carousel.destroy();
            carouselInstance = null;
            carouselSpecialEl.innerHTML = originalHTML;
        };

        const updateCarousel = () => {
            shouldEnableCarousel() ? createCarousel() : destroyCarousel();
        };

        updateCarousel();

        window.addEventListener("resize", () => {
            const currentIsMobile = window.innerWidth <= 768;

            if (currentIsMobile !== lastIsMobile) {
                updateCarousel();
                lastIsMobile = currentIsMobile;
            }
        });
    }

    window.addEventListener('scroll', () => {
        scrollActiveAnchor();
        scrollSticky();
    });

    window.addEventListener('resize', () => {
        scrollActiveAnchor();
    });

    window.addEventListener('load', () => {
        scrollActiveAnchor();
        scrollSticky();
    });

    scrollActiveAnchor();
    activeCarouselStickyLink();
    scrollSticky();

    
    let carouselUseCasesEl = document.getElementById('jsCarouselUseCases'),
        useCasesTabItemEls = document.querySelectorAll('.jsUseCasesTabItem'),
        useCasesTabEl = document.getElementById('jsUseCasesTab'),
        useCasesOffsetTop = 134;
    if (carouselUseCasesEl && useCasesTabItemEls.length > 0) {
        if(window.innerWidth <= 992) {
            useCasesOffsetTop = 181;
        }
        const carouselUseCases = new Carousel(carouselUseCasesEl.id, {
            autoWidth: false,
            autoHeight: true,
            autoplay: false,
            speed: 1000,
            pagination: true,
            arrows: true,
            type: 'fade',
            rewind: true
        });

        useCasesTabItemEls.forEach((tabItemEl, index) => {
            tabItemEl.addEventListener('click', (e) => {
                e.preventDefault();
                carouselUseCases.carousel.go(index);
            });
        });

        carouselUseCases.carousel.on('mounted move', () => {
            useCasesTabItemEls.forEach((tabItemEl) => tabItemEl.classList.remove('current'));
            const activeTabItemEl = useCasesTabItemEls[carouselUseCases.carousel.index];
            if (activeTabItemEl) {
                activeTabItemEl.classList.add('current');
                const offTop = useCasesTabEl.offsetTop;
                let scrollOffset = offTop - useCasesOffsetTop;
                if (window.innerWidth < 992) {
                    scrollOffset += carouselUseCases.carousel.index * 56;
                }

                $('body, html').stop().animate({ scrollTop: scrollOffset }, 500);
            }
        });
    }
}

export function rankCarousel() {
    let rankCarouselEl = document.getElementById('jsRankCarousel');
    const isSP = window.matchMedia('(max-width: 768px)').matches;
    if (rankCarouselEl && isSP) {
        new Carousel('jsRankCarousel', {
            arrows: false,
            pagination: false,
            gap: '10px',
            type: 'loop',
            focus: 'center',
            fixedWidth: 200,
        });
    }
}
